 <div class="navigation">
      <img class="image-back" src="assets/images/back.png" (click)="goBack()" alt="Back">
      <span class="label-back">Back to {{title}}</span>
     </div>